import React from "react";
import { Field } from "formik";
import Tooltip from "@mui/material/Tooltip";
import WarningIcon from "@mui/icons-material/Warning";
import { pink } from "@mui/material/colors";

const TableLLIField = ({
  element,
  childOpt,
  pageId,
  schemaItem,
  option,
  error,
  id,
  tdkeys,
  rowkeys,
  tableName,
  name,
  errorBorder,
  values,
  disabled,
}) => {

    if (
      childOpt &&
      childOpt.childPageId === pageId &&
      childOpt.childItemId === schemaItem
    ) {
      option = childOpt.optionsData;
    }
    return (
      <div className="wrapper">
        <div className="form-field">
          <Field
            as="select"
            className={`tableInput ${errorBorder}`}
            id={id + tdkeys + 1}
            rowkeys={tdkeys}
            tdkeys={rowkeys}
            name={`${tableName}[${tdkeys}].${name}`}
            data-testid="TableSelectField"
            value={values?.[tableName]?.[tdkeys]?.[name] || ""}
          >
            <option value=""></option>
            {option.map((i, index) => (
              <option
                key={index}
                value={element?.prefix === "LLI" ? i.label : i.value}
              >
                {i.label}
              </option>
            ))}
          </Field>
          {error?.[name] && (
            <span className="icon">
              <Tooltip title={error[name]}>
                <WarningIcon sx={{ color: pink[500] }} />
              </Tooltip>
            </span>
          )}
        </div>
      </div>
    );

};

export default TableLLIField;
